import { useState } from 'react';
import ProfitabilityFilters from './profitability/ProfitabilityFilters';
import ProfitabilityMetrics from './profitability/ProfitabilityMetrics';
import ProfitLossStatement from './profitability/ProfitLossStatement';

function Profitability() {
  const [currentFilters, setCurrentFilters] = useState({
    dateRange: '30d',
    salesChannel: 'all',
    product: 'all',
    sku: 'all'
  });

  // Sample data - replace with actual data from your backend
  const metrics = {
    grossProfitMargin: 0.45,
    grossProfitMarginChange: 0.05,
    netProfitMargin: 0.28,
    netProfitMarginChange: 0.03,
    averageOrderValue: 125,
    averageOrderValueChange: 0.08,
    customerAcquisitionCost: 35,
    customerAcquisitionCostChange: -0.12
  };

  const plStatement = {
    revenue: [
      { label: 'Gross Sales', value: 250000 },
      { label: 'Returns & Refunds', value: -15000 },
      { label: 'Net Sales', value: 235000, isTotal: true }
    ],
    costOfGoods: [
      { label: 'Product Cost', value: -100000 },
      { label: 'Shipping & Handling', value: -20000 },
      { label: 'Total Cost of Goods', value: -120000, isTotal: true }
    ],
    operatingExpenses: [
      { label: 'Marketing & Advertising', value: -25000 },
      { label: 'Marketplace Fees', value: -15000 },
      { label: 'Storage Fees', value: -5000 },
      { label: 'Customer Service', value: -8000 },
      { label: 'Total Operating Expenses', value: -53000, isTotal: true }
    ],
    netProfit: 62000
  };

  const handleFilterChange = (filters) => {
    setCurrentFilters(filters);
    // Here you would typically fetch new data based on the filters
  };

  return (
    <div>
      <h1 className="text-4xl font-bold mb-8">Profitability Analysis</h1>
      
      <ProfitabilityFilters onFilterChange={handleFilterChange} />
      
      <ProfitabilityMetrics metrics={metrics} />
      
      <ProfitLossStatement data={plStatement} />
    </div>
  );
}

export default Profitability;